import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Tag} from './bot-tags/bot-tags.component';
import { BotService } from '../../../services/bot.service';
import {FlowManagerService} from '../../../services/flow-manager.service';
import {Observable} from 'rxjs';
import {SharedService} from '../../../../../core/services/store/shared-store/shared-storage.service';
import {swalMini} from '../../../../../shared/utils/utils';
import { newStepValue } from '../../../services/flowBuilder/utils/constants';
import {MatOption} from "@angular/material/core";
import {Router} from '@angular/router';
import {tap} from "rxjs/operators";

const URL_REGEX: RegExp =
    /^(?:http[s]?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&'\(\)\*\+\|,;=.]+$/;

@Component({
  selector: 'app-bot-modal',
  templateUrl: './bot-modal.component.html',
  styleUrls: ['./bot-modal.component.scss']
})
export class BotModalComponent implements OnInit {

  savingInProgress: Boolean = false;
  botForm: FormGroup;
  nextForm;
  currentSteps = [];
  tags: Tag[] = [];
  isTagsTouched = false;
  isEditMode = false;
  botId = '';
  loadingData = true;
  botMetaData: any;
  supportedChannels: string[] = [];
  existingBotTagList: string[] = [];
  botList: string[] = [];
  flowsMetadata: any;
  flowDataSource: Observable<any[]>;
  flow: any;
  startFlowIdStep: '';
  isFirstTimeLoad: false;
  checkDuplicates = false;
  channelFilters = [];
  @ViewChild("allSelected") allSelected: MatOption;
  private supportedChannelsData$: any;
  getValues: boolean = false;
  currentChannels: any[];
  channelListObj = {};
  templateName = '';
  isSupportedChannels = true;

  constructor(
    public dialogRef: MatDialogRef<BotModalComponent>,
    private botFromBuilder: FormBuilder,
    private botService: BotService,
    private flowManagerService: FlowManagerService,
    public sharedService: SharedService,
    private router: Router
  ) {
    this.buildForm();
    this.nextForm = new FormGroup({
      next: new FormControl('start')
    });

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  buildForm() {
    this.botForm = this.botFromBuilder.group({
      botName: new FormControl( '', [Validators.required]),
      templateName: new FormControl( '', [Validators.required]),
      botDescription: new FormControl('',[Validators.required]),
      imageLink: new FormControl( '', [Validators.required, Validators.pattern(URL_REGEX)]),
      videoLink: new FormControl('', [Validators.required, Validators.pattern(URL_REGEX)]),
      tags: new FormControl( '', [Validators.required]),
      botStartNode: new FormControl( '', []),
      supportedChannel: new FormControl( '', [Validators.required])
    });

  }

  ngOnInit(): void {
    if (this.dialogRef._containerInstance._config.data && this.dialogRef._containerInstance._config.data.isEdit) {
      this.isEditMode = this.dialogRef._containerInstance._config.data.isEdit;
      if (!this.isEditMode) { this.loadingData = false; }
      this.botId = this.dialogRef._containerInstance._config.data.botData.id;
      this.getAllChannels();
    } else {
      this.getAllChannels();
      this.flow = this.dialogRef._containerInstance._config.data.flow;
    }

    this.flowManagerService.getFlowMetaData(true).subscribe((value) => {
      this.flowsMetadata = value;
    });
    this.currentSteps.push(newStepValue);
  }


  updateTagsList(tagsList) {
    this.botForm.controls['tags'].setValue(tagsList.map(tag => tag.name));
    this.tags = tagsList;

    const values = this.tags.map(function(item) { return item.name.toLowerCase(); });
    this.checkDuplicates = values.some(function(item, index) {
      return values.indexOf(item) !== index;
    });
  }

  updateTagsTouched(isTouched) {
    this.isTagsTouched = isTouched;
  }

  perOne(all){
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return false;
    }
    if(this.botForm.controls.supportedChannel.value.length==this.channelFilters.length)
      this.allSelected.select();
  }


  toggleAllSelection() {
    if (this.allSelected.selected) {
      this.botForm.controls.supportedChannel
          .patchValue([0,...this.channelFilters.map(item => item.channelId)]);
    } else {
      this.botForm.controls.supportedChannel
          .patchValue([]);
    }
  }

  onChannelRemoved(userChannel: any) {
    const channels = this.botForm.controls.supportedChannel.value;
    this.removeChip(channels, userChannel);
    this.botForm.controls.supportedChannel.setValue(channels);
  }

  removeChip<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  getAllChannels() {
    this.flowManagerService.getChannelList(true).pipe(
        tap((resp: any) => {
              if (resp.status === 200) {
                this.getValues = true;
                let currentList = [];
                let holderObject = {};
                const holderValues = resp.body;
                for (const holderItem in holderValues) {
                  let currentHolderObject = {
                    channelId: holderValues[holderItem]['channel-id'],
                    channelName: holderValues[holderItem]['channel-name']
                  };
                  this.channelListObj = {
                    ...this.channelListObj,
                    [currentHolderObject.channelId]: currentHolderObject.channelName
                  }
                  currentList.push(currentHolderObject);
                  Object.assign(holderObject, currentList);
                }
                this.botForm.controls.supportedChannel.patchValue(currentList);
                return this.supportedChannelsData$ = currentList;
              } else {
                this.getValues = false;
              }
            }
        )
    ).subscribe(
        () => {
          this.channelFilters = this.supportedChannelsData$;
          if(!this.isEditMode) {
            this.disableSupportedChannels(this.channelFilters);
          }
          return this.channelFilters;
        },
        () => {
        },
        () => {
          this.fetchBotData();
        }
    );
  }

  saveBot() {
    if(this.canSaveBot()) {
      this.savingInProgress = true;
      const botData = this.botForm.getRawValue();
      this.currentChannels = this.botForm.controls.supportedChannel.value;

      if(this.currentChannels[0]==0) {
        this.currentChannels.shift();
      }
      const stageBotRequest = {
        name: botData.botName,
        description: botData.botDescription,
        pictureLink: botData.imageLink,
        videoLink: botData.videoLink,
        tags: botData.tags,
        supportedChannels: this.currentChannels
      }
      this.templateName = botData.templateName;

      if (!this.isEditMode) {
        this.botService.saveNewBot(stageBotRequest).subscribe(
          (botData) => {
            if(botData.status === 200) {
              // construct create template req
              const stageTemplateRequest = {
                flowName: this.templateName,
                flowPath: botData.body.id + '/' + this.templateName,
                flow: this.flow,
                message: ''
              }

              this.botService.saveTemplate(stageTemplateRequest).subscribe(
                (templateData) => {
                  if(templateData.status === 200) {
                    swalMini({
                      title: 'Saved successfully!',
                      text: '',
                      type: 'success',
                    });
                      this.savingInProgress = false;
                      this.dialogRef.close();
                    this.successfullCreateOrUpdate(templateData.body);


                  } else {
                    this.savingInProgress = false;
                    swalMini({
                      title: 'Problem occurred while saving',
                      text: '',
                      type: 'warning',
                    });
                  }
                },
                error => {
                  this.savingInProgress = false;
                  swalMini({
                    title: 'Problem occurred while saving',
                    text: '',
                    type: 'warning',
                  });
                },
                () => {}
              );

            } else {
              swalMini({
                title: 'Problem occurred while creating bot',
                text: '',
                type: 'warning',
              });
            }
          },
          error => {
            this.savingInProgress = false;
            swalMini({
              title: 'Problem occurred while creating bot',
              text: '',
              type: 'warning',
            });
          },
          () => {}
        );
      } else {
        // edit an existing bot
        const stageUpdateBotRequest = {
            ...this.botMetaData,
            name: botData.botName,
            description: botData.botDescription,
            pictureLink: botData.imageLink,
            videoLink: botData.videoLink,
            tags: botData.tags,
            supportedChannels: botData.supportedChannel,
            startFlowIdStep: this.nextForm.get('next').value,
            placeholders: []

        };
        this.botService.updateExistingBot(this.botMetaData.id, stageUpdateBotRequest).subscribe(
          data => {
            swalMini({
              title: 'Saved successfully!',
              text: '',
              type: 'success',
            });
              this.savingInProgress = false;
              this.dialogRef.close();
              this.refreshBotUI();
          },
          error => {
            this.savingInProgress = false;
            swalMini({
              title: 'Problem occurred while updating bot',
              text: '',
              type: 'warning',
            });
          },
          () => {}
        );
      }
        this.savingInProgress = false;
    } else {
      swalMini({
        title: 'Validation failed',
        text: '',
        type: 'warning',
      });
    }
  }
  refreshBotUI() {
    this.sharedService.clearEntityConfigs();
    this.flowManagerService.getFlows(true).subscribe((flows) => {
      this.sharedService.updateFlows(flows);
    });
  }

  private successfullCreateOrUpdate(isSuccess) {
    this.flowManagerService.clearFlowNameCache();
    const path = isSuccess.flowMetaData
          ? isSuccess.flowMetaData.directory
          : this.sharedService.flow.metaData.directory;

    let flowPath = this.extractFlowPath(path).replace(/\//g, ',');
    const flowId = isSuccess.flowMetaData
          ? isSuccess.flowMetaData.flowId
          : this.sharedService.getFlowRef;
      flowPath = flowPath + flowId;
      // @ts-ignore
    this.saveFlowStatus = false;

    this.sharedService.setNewFlowSaved(true);
    this.router.navigate([
        'flow',
        this.sharedService.getEnvironment(),
        this.sharedService.getEntityType(),
        this.sharedService.getEntityId(),
        flowPath,
      ]);
  }

  extractFlowPath(flowPath: any) {
    const lastIndexOf = flowPath.lastIndexOf('/');
    const path = lastIndexOf !== -1 ? flowPath.slice(0, lastIndexOf) + ',' : '';
    return path;
  }


  checkBotName(botName: string) {
    return this.botList.length > 0 && this.botList.indexOf(botName.toLowerCase()) !== -1;
  };

  closeModal() {
    this.dialogRef.close();
  }

  canSaveBot() {
    if (!this.isEditMode) {
    return this.botForm.valid && !this.checkBotName(this.botForm.controls['botName'].value);
    } else {
      return this.botForm.valid && !this.checkBotName(this.botForm.controls['botName'].value) && this.validateBotStartNode();
    }
  }

  getformValue(form: FormGroup, controlName: string) {
    return form.get(controlName).value;
  }

  fetchBotData() {
    this.botService.getBot(this.botId).subscribe(
      (data) => {
        this.botMetaData = data.body;
      },
      error => {
        this.loadingData = false;
      },
      () => {
        if (this.isEditMode) {
        this.setData(); }
        if (!this.isEditMode) {
          this.botForm.controls.supportedChannel.setValue([]) ;
        }
        this.fetchBotList();
        this.loadingData = false;
      }
    );
  }

  fetchBotList() {
    this.botService.getBotList().subscribe(
        (data) => {
          const fetchedBotList = Object.values(data.body['bots']);
          const botNames = fetchedBotList.map(element => {
            return element.toString().toLowerCase();
          });
          if (this.isEditMode) {
          this.botList = botNames.filter((element) => {
            return element !== this.botMetaData.name.toLowerCase();
          }); } else {
          this.botList = botNames;
          }

        },
        error => {
          swalMini({
            title: 'Problem occurred, try again',
            text: '',
            type: 'warning',
          });
        },
        () => {
        }
    );
  }

  disableSupportedChannels(channelsValue) {
    this.isSupportedChannels = channelsValue[0] === 0 && channelsValue.length === 1 ? false : channelsValue.length > 0 ? true : false;
    // if no supported channels disable supportedChannels dropdown
    if(!this.isSupportedChannels) {
      this.botForm.controls.supportedChannel.disable();
    }
  }

  setData() {
    let channelsValue: any;
    if (this.botMetaData.supportedChannels) {
      if (this.botMetaData.supportedChannels.length === this.channelFilters.length) {
        channelsValue = [0 , ... this.botMetaData.supportedChannels]; // check ['SMS', 'WhatsApp']
      } else {
        channelsValue = this.botMetaData.supportedChannels; // ['SMS'] or ['WhatsApp']
      }
    } else {
      channelsValue = [];
    }
    this.disableSupportedChannels(channelsValue);

    this.botForm.setValue({
      botName: this.botMetaData.name,
      templateName: 'noValue',
      botDescription: this.botMetaData.description,
      imageLink: this.botMetaData.pictureLink,
      videoLink: this.botMetaData.videoLink,
      tags: this.botMetaData.tags,
      botStartNode: this.botMetaData.startFlowIdStep,
      supportedChannel: channelsValue
    });
    if (this.botMetaData.startFlowIdStep !== null) {
      this.nextForm.setValue({
        next: this.botMetaData.startFlowIdStep
      });
    } else {
      this.nextForm.setValue({
        next: 'start'
      });
    }

    this.supportedChannels = this.botMetaData.supportedChannels;
    if (this.botMetaData.tags !== null) {
    this.existingBotTagList = this.botMetaData.tags.map((tag) => {
      return {
        name: tag
      };
    });
    this.tags = this.botMetaData.tags;
    }
  }

  supportedChannelChange(selectedChannel: string) {
    console.log('on channel change selectedChannel ', selectedChannel);
  }

  validateBotStartNode() {
   let isValid = true;
     if (this.nextForm.get('next').value === null || !this.nextForm.get('next').value.includes(':')) {
       isValid = false;
     }
     return isValid;
  }

}
